import { kebabCase } from "lodash";
import { TIER_1_COUNTRY } from "../enums/country";
import { QueryLayer } from "../types/queryState";

type IndicatorOptions = {
  isLandCoverMasked?: boolean;
  isDetrended?: boolean;
};

const VEGETATION_INDICATOR = "vegetation";
const HYBRID_INDICATOR = "hybrid-index";

export const toIndicatorName = (displayName: string) => kebabCase(displayName);

export const isVegetationIndicator = (displayName: string) =>
  toIndicatorName(displayName) === VEGETATION_INDICATOR;

export const isTier1Country = (country: string) =>
  TIER_1_COUNTRY.includes(country);

export const layerUsesVegetation = (
  layer?: Pick<QueryLayer, "displayName" | "parameters">,
) => {
  if (!layer) return false;

  if (isVegetationIndicator(layer.displayName)) {
    return true;
  }

  if (toIndicatorName(layer.displayName) !== HYBRID_INDICATOR) {
    return false;
  }

  return (
    layer.parameters?.some((parameter) =>
      isVegetationIndicator(parameter.name),
    ) ?? false
  );
};

export const isDetrendedAvailable = ({
  country,
  layers,
}: {
  country: string;
  layers: QueryLayer[];
}) => isTier1Country(country) && layers.some((layer) => layer.active && layerUsesVegetation(layer));

export const buildIndicatorName = (
  displayName: string,
  { isLandCoverMasked = false, isDetrended = false }: IndicatorOptions = {},
) => {
  let indicatorName = toIndicatorName(displayName);

  if (indicatorName === VEGETATION_INDICATOR && isDetrended) {
    indicatorName = `${indicatorName}-detrended`;
  }

  if (isLandCoverMasked) {
    indicatorName = `${indicatorName}-masked`;
  }

  return indicatorName;
};
